// usage:
// const myItems = [{ id: 'hbe6u', type: 'Ig::Account'}, { id: 'hbe6v', type: 'YtAccount'}]
// console.log((myItems |> byTypedId({ id: 'hbe6v', type: 'Ig::Account })).name)

export default typedId => collection =>
  collection.find(
    item => item.id === typedId?.id && item.type === typedId?.type
  )
